import React, { FC } from "react";
import { createLineProps } from "./CreateLineProps";
import colors from "Styles/colors";
import { DPPayPeriodSummary } from "Shared/types/Payments";
import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";

const w = 400; // total width of the pill
const h = 20; // total height of the pill
const r = 7; // border radius of the four corners of the pill
const diff = (h - r * 2) / 2; // half the length of the flat sides of the pill

/* Path d attr: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d */

const useStyles = makeStyles({
  root: {
    width: w,
    height: h,
    margin: "auto",
    marginBottom: 22,
  },
});

const DPPercentagePill: FC<DPPayPeriodSummary> = props => {
  const lines = createLineProps(props, w);
  const classes = useStyles();

  if (!lines.length) {
    return null;
  }

  const firstBar = lines[0];
  const middleBar = lines.length > 2 ? lines[1] : null;
  const lastBar = lines[lines.length - 1];

  const onlyOneValue = lines.length === 1;

  return (
    <Box className={classes.root}>
      <svg viewBox={`0 0 ${w} ${h}`} xmlns="http://www.w3.org/2000/svg">
        {onlyOneValue ? (
          <path
            fill={colors[firstBar.color]}
            d={`
                M ${firstBar.start},${h / 2}
                L ${firstBar.start},${h / 2 - diff}
                A ${r},${r} 0,0,1 ${firstBar.start + r},0
                L ${firstBar.end - r},0
                A ${r},${r} 0,0,1 ${firstBar.end},${h / 2 - diff}
                L ${firstBar.end},${h / 2 + diff},
                A ${r},${r} 0,0,1 ${firstBar.end - r},${h}
                L ${firstBar.start + r},${h}
                A ${r},${r} 0,0,1 ${firstBar.start},${h / 2 + diff}
                L ${firstBar.start},${h / 2}
                z
              `}
          />
        ) : (
          <>
            <path
              fill={colors[firstBar.color]}
              d={`
                M ${firstBar.start},${h / 2}
                L ${firstBar.start},${h / 2 - diff}
                A ${r},${r} 0,0,1 ${firstBar.start + r},0
                L ${firstBar.end},0
                L ${firstBar.end},${h},
                L ${firstBar.start + r},${h}
                A ${r},${r} 0,0,1 ${firstBar.start},${h / 2 + diff}
                L ${firstBar.start},${h / 2}
                z
              `}
            />
            {middleBar ? (
              <path
                fill={colors[middleBar.color]}
                d={`
                  M ${middleBar.start},${0}
                  L ${middleBar.end},${0}
                  L ${middleBar.end},${h},
                  L ${middleBar.start},${h}
                  L ${middleBar.start},${0}
                  z
                `}
              />
            ) : null}
            <path
              fill={colors[lastBar.color]}
              d={`
                M ${lastBar.end},${h / 2}
                L ${lastBar.end},${h / 2 + diff}
                A ${r},${r} 0,0,1 ${lastBar.end - r},${h}
                L ${lastBar.start}, ${h}
                L ${lastBar.start}, 0
                L ${lastBar.end - r}, 0
                A ${r},${r} 0,0,1 ${lastBar.end},${h / 2 - diff}
                L ${lastBar.end},${h / 2}
                z
              `}
            />
          </>
        )}
      </svg>
    </Box>
  );
};

export default DPPercentagePill;
